

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useNotification } from "../../toster-notification/NotificationContext";
import { LocalLinksInfoDTO } from "../../../models/local/local.response";
import { localService } from "../../../services/localService";
import Loader from "../../shared/Loader";

export default function RestourantLinks() {
    const { slug } = useParams();

    const [loading, setLoading] = useState<boolean>(false);
    const { notify } = useNotification();
    const navigate = useNavigate();

    const [data, setData] = useState<LocalLinksInfoDTO | null>(null);

    useEffect(() => {
        fetchLocalLinksInfo();
    }, [slug]);

    const fetchLocalLinksInfo = async () => {
        if (!slug) {
            notify("error", "Invalid restaurant slug.");
            return;
        }

        setLoading(true);
        try {
            const response = await localService.getLocalLinksBySlug(slug);

            if (response.success && response.data) {
                setData(response.data);
            } else {
                notify("error", "Failed to fetch restaurant links.");
            }
        } catch (error) {
            console.error("Error fetching restaurant links:", error);
            notify("error", "An error occurred while fetching restaurant links.");
        }
        finally {
            setLoading(false);
        }
    }

    if (loading) {
        return <Loader />;
    }

    if (!data) {
        return <div>Restaurant links not found.</div>;
    }

    return (
        <>

            <section className="links-section">
                <div className="w-layout-blockcontainer container w-container">
                    <div className="content-wrapper client-links">
                        <div className="links-block">
                            <div
                                className="text-block-57"
                                style={{ color: data?.primaryColor || "" }}
                            >
                                Dobrodošli!
                            </div>
                            <div className="text-block-56">{data?.name || "Restoran"}</div>
                            <div
                                className="links-local-image-div"
                                style={{
                                    backgroundImage: data?.primaryColor
                                        ? `linear-gradient(135deg, ${data.primaryColor + "95"}, ${data.primaryColor})`
                                        : "linear-gradient(135deg, #9a7af3, #2317e5)",
                                    boxShadow: `0 12px 28px ${data?.primaryColor ? data.primaryColor + "40" : "#2317e540"}`,
                                }}
                            >
                                <img
                                    src={data.logoImageUrl + "@ul.webp"}
                                    loading="lazy"
                                    sizes="100vw"
                                    alt=""
                                    className="image-23" />
                            </div>
                            <div className="links-buttons">

                                <div
                                    className="button-primary-2 client-links"
                                    style={{ background: data?.primaryColor || "" }}
                                    onClick={() => navigate(`/client-menu/${data.id}/online`)}
                                >
                                    <div>Pogledajte meni</div>
                                </div>

                                {data.googleReviewURL && (
                                    <div className="button-primary-2 secondary client-links" onClick={() => window.open(data.googleReviewURL, "_blank")}>
                                        <div>Ostavite Google recenziju</div>
                                    </div>
                                )}

                            </div>
                            <div className="div-block-108">
                                <div className="text-block-55">
                                    <span className="text-span-11">power by </span>
                                    Quick Menu
                                </div>
                                <div className="links-logo-div">
                                    <img
                                        src="https://cdn.prod.website-files.com/6919e066813f7ba31cee91ac/6a15f1cef0187d14f01d1688_Subtract.png"
                                        loading="lazy"
                                        sizes="100vw"
                                        alt=""
                                        className="image-22" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
};